// https://github.paypal.com/pages/Globalization-R/griffin-paypal/docs/name-client.html
import { get } from 'lodash'
import { useSelector } from './p2p-connect'
import griffinName from 'griffin-paypal/name'
import getGriffinMetadata, { useGriffinMetadata } from './griffin-utils'

export function getInformalName({
  givenName = '',
  surname = '',
  country = '',
  griffinMetadata = getGriffinMetadata(),
}) {
  let informalName = ''

  // safeguard against undefined
  if (!givenName || !surname || !country || !griffinMetadata) {
    return informalName
  }

  const griffinNameHandler = griffinName.createHandler(griffinMetadata)
  const options = {
    country,
    style: griffinNameHandler.NAME_FORMAT_INFORMAL,
  }

  // Potentially can throw an error if country is not available
  try {
    const nameObject = { givenName, surname }
    informalName = griffinNameHandler.formatName(nameObject, options)
  } catch (exception) {
    // Do nothing since informalName is already empty string
  }
  return informalName
}

export function useInformalName({ givenName = '', surname = '' }) {
  const griffinMetadata = useGriffinMetadata()
  const country = useSelector(state => get(state, 'server.country', {}))
  return getInformalName({
    givenName,
    surname,
    country,
    griffinMetadata,
  })
}
